var _circle, _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyOptionsMob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 246,
    viewBox: "0 0 246 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 123,
    r: 123,
    fill: "url(#paint0_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 246,
    height: 246
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 123,
    r: 123,
    fill: "url(#paint1_linear)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.2454,
    y: 52.4902,
    width: 173,
    height: 194.274,
    rx: 1.93237,
    transform: "rotate(-0.0805182 36.2454 52.4902)",
    fill: "black"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.2454,
    y: 52.4902,
    width: 173,
    height: 194.274,
    rx: 1.93237,
    transform: "rotate(-0.0805182 36.2454 52.4902)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2486 53.7305C36.2471 52.6632 37.111 51.7969 38.1782 51.7954L207.314 51.5577C208.381 51.5562 209.247 52.4201 209.249 53.4873L209.26 61.5671L36.2599 61.8102L36.2486 53.7305Z",
    fill: "#646B7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.956 58.989C47.3383 58.987 48.4572 57.865 48.4552 56.4827C48.4533 55.1005 47.3312 53.9816 45.949 53.9835C44.5668 53.9855 43.4479 55.1076 43.4498 56.4898C43.4517 57.872 44.5738 58.9909 45.956 58.989Z",
    fill: "#4E5465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4027 58.989C55.7849 58.987 56.9038 57.865 56.9019 56.4827C56.8999 55.1005 55.7779 53.9816 54.3957 53.9835C53.0134 53.9855 51.8945 55.1076 51.8965 56.4898C51.8984 57.872 53.0205 58.9909 54.4027 58.989Z",
    fill: "#AAAFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5366 58.989C63.9188 58.987 65.0377 57.865 65.0358 56.4827C65.0339 55.1005 63.9118 53.9816 62.5296 53.9835C61.1474 53.9855 60.0284 55.1076 60.0304 56.4898C60.0323 57.872 61.1544 58.9909 62.5366 58.989Z",
    fill: "#AAAFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.8368,
    y: 76.3447,
    width: 128.178,
    height: 62.1603,
    rx: 1.28824,
    transform: "rotate(-0.0805182 57.8368 76.3447)",
    fill: "#F4F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.108 94.4206C100.667 97.803 101.126 109.647 103.376 118.32L114.672 119.854L121.734 99.519C121.056 97.2569 119.947 95.4487 118.293 94.4206L112.187 93.5862L106.108 94.4206Z",
    fill: "#48D29E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.376 118.32C104.279 121.792 105.467 124.756 106.68 126.462C107.276 127.299 107.699 127.786 109.131 127.81H109.365H112.201H115.035H115.269C115.345 127.81 115.418 127.807 115.489 127.803C115.156 127.753 115.78 127.313 115.815 126.968L116.399 121.388L114.444 118.32H103.376Z",
    fill: "#43C594"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.995 109.34L126.929 110.895L127.461 112.949L133.507 113.786L139.946 112.949C141.142 110.323 138.705 107.089 137.024 106.246C136.353 109.619 131.779 109.151 127.995 109.34Z",
    fill: "#FFDB81"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.136 86.762V91.0167L112.202 91.9692L117.264 91.0167V86.762C117.264 86.5469 117.087 86.3696 116.87 86.3696H107.531C107.314 86.3696 107.136 86.5469 107.136 86.762Z",
    fill: "#365E7D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.136 91.0164C106.571 91.0164 106.108 91.4797 106.108 92.047V94.4202H118.292V92.0469C118.292 91.4796 117.829 91.0164 117.264 91.0164H107.136V91.0164Z",
    fill: "#F9F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.946 112.949H127.461L126.582 114.413L127.057 115.677H141.142V113.214C141.142 113.068 141.023 112.949 140.879 112.949H139.946Z",
    fill: "#F9F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.057 115.677L126.213 121.387V124.985H138.086C140.324 123.99 141.893 121.744 141.893 119.149V116.086C141.893 115.861 141.711 115.677 141.484 115.677H141.142H127.057Z",
    fill: "#234CFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.566 124.985H123.694V127.115C123.694 127.462 123.436 127.751 123.105 127.803C123.145 127.807 123.185 127.81 123.228 127.81H134.63C135.145 127.81 135.566 127.389 135.566 126.874V124.985Z",
    fill: "#365E7D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.268 107.765C137.402 109.169 138.225 111.195 137.426 112.949H138.359H139.945C141.141 110.323 138.704 107.089 137.024 106.246C136.899 106.877 136.636 107.373 136.268 107.765Z",
    fill: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.622 113.214V115.677H138.967H141.142V113.214C141.142 113.068 141.024 112.949 140.879 112.949H139.946H138.36C138.473 112.949 138.57 113.023 138.608 113.124C138.617 113.153 138.622 113.181 138.622 113.214Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.376 116.086V119.149C139.376 121.744 137.804 123.99 135.566 124.985H138.085C140.324 123.99 141.893 121.744 141.893 119.149V116.086C141.893 115.861 141.711 115.677 141.484 115.677H141.142H138.967C139.192 115.677 139.376 115.861 139.376 116.086Z",
    fill: "#3259FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.566 124.985V126.874C135.566 127.389 135.145 127.81 134.63 127.81H137.149C137.665 127.81 138.085 127.389 138.085 126.874V124.985H135.566Z",
    fill: "#2B4D66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.739 100.034L112.145 102.783L120.576 105.927L128.965 102.783L129.371 100.034C129.411 99.7649 129.303 99.519 128.882 99.519C123.332 99.519 117.78 99.519 112.228 99.519C111.81 99.519 111.698 99.7649 111.739 100.034Z",
    fill: "#F9F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.898 121.388V127.115C114.898 127.462 115.156 127.753 115.489 127.803C115.522 127.807 115.558 127.81 115.593 127.81H125.518C125.554 127.81 125.589 127.807 125.622 127.803C125.955 127.751 126.213 127.462 126.213 127.115V124.985V121.388C124.358 121.388 122.857 119.149 121.001 119.149C119.084 119.149 116.815 121.388 114.898 121.388Z",
    fill: "#F9F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.466 104.95L114.445 118.319L114.898 121.387H126.213L127.057 115.677L127.461 112.949L127.995 109.34L128.964 102.783H122.396H112.145L112.466 104.95Z",
    fill: "#365E7D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.554 108.702C118.791 108.702 117.359 110.16 117.359 111.961C117.359 113.762 118.791 115.223 120.554 115.223C120.98 115.223 121.384 115.138 121.753 114.987L121.769 114.98C122.637 114.616 123.315 113.871 123.601 112.949C123.698 112.64 123.75 112.306 123.75 111.961C123.75 111.507 123.66 111.075 123.495 110.682C123.277 110.165 122.934 109.716 122.502 109.375C121.963 108.952 121.287 108.702 120.554 108.702Z",
    fill: "#E97B93"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.382 127.81H125.518C125.554 127.81 125.589 127.807 125.622 127.803C125.956 127.751 126.213 127.462 126.213 127.115V124.985V121.388H124.072V124.985V127.115C124.072 127.462 123.816 127.751 123.483 127.803C123.45 127.807 123.415 127.81 123.382 127.81Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.232 100.034L126.825 102.783H128.964L129.371 100.034C129.411 99.7649 129.302 99.519 128.882 99.519H126.743C127.161 99.519 127.272 99.7649 127.232 100.034Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.7 103.632L125.854 109.34L125.821 109.574L125.32 112.949L124.918 115.677L124.183 120.645L124.072 121.387H126.213L127.057 115.677L127.461 112.949L127.995 109.34L128.964 102.783H126.825L126.7 103.632Z",
    fill: "#2B4D66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.611 111.961C121.611 112.306 121.559 112.64 121.46 112.949C121.174 113.871 120.498 114.616 119.628 114.98L119.614 114.987C119.571 115.003 119.529 115.02 119.484 115.036C119.82 115.157 120.179 115.223 120.555 115.223C120.98 115.223 121.384 115.138 121.753 114.987L121.769 114.98C122.637 114.616 123.315 113.871 123.601 112.949C123.698 112.64 123.75 112.306 123.75 111.961C123.75 111.507 123.66 111.075 123.495 110.682C123.277 110.165 122.935 109.716 122.502 109.375C121.963 108.952 121.287 108.702 120.555 108.702C120.179 108.702 119.82 108.768 119.484 108.888C119.803 109.004 120.098 109.17 120.361 109.375C120.793 109.716 121.138 110.165 121.356 110.682C121.519 111.075 121.611 111.507 121.611 111.961Z",
    fill: "#E06A84"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.274 124.505C118.049 124.505 117.865 124.69 117.865 124.914V126.255V127.81H123.244V124.914C123.244 124.69 123.06 124.505 122.835 124.505H118.848H118.274Z",
    fill: "#D0CEE7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.894 86.762V91.0167H113.892H113.894H117.262H117.264V86.762C117.264 86.5469 117.087 86.3696 116.87 86.3696H113.502C113.717 86.3696 113.894 86.5469 113.894 86.762Z",
    fill: "#2B4D66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.757 91.4868C114.863 91.6499 114.925 91.8414 114.925 92.0469V94.4201H118.293V92.0469C118.293 91.4796 117.829 91.0164 117.265 91.0164H117.262H113.894C114.256 91.0164 114.575 91.2055 114.757 91.4868Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.924 94.4204C116.576 95.4486 117.685 97.2569 118.363 99.5188H120.554H121.734C121.055 97.2568 119.947 95.4486 118.292 94.4204H114.924Z",
    fill: "#51DFAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.449 118.421C130.416 118.421 129.577 119.277 129.577 120.331C129.577 121.385 130.416 122.241 131.449 122.241C132.482 122.241 133.318 121.385 133.318 120.331C133.318 119.277 132.482 118.421 131.449 118.421Z",
    fill: "#2F56FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.827 104.95C101.631 109.283 102.298 114.164 103.376 118.319H114.445L112.466 104.95H101.827Z",
    fill: "#F9F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.351 150.202C140.351 147.743 142.345 145.749 144.804 145.749H152.092C154.551 145.749 156.545 147.743 156.545 150.202C156.545 152.662 154.551 154.656 152.092 154.656H144.804C142.345 154.656 140.351 152.662 140.351 150.202Z",
    fill: "#234CFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.092 153.441C153.881 153.441 155.331 151.991 155.331 150.202C155.331 148.413 153.881 146.963 152.092 146.963C150.303 146.963 148.853 148.413 148.853 150.202C148.853 151.991 150.303 153.441 152.092 153.441Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.172,
    y: 148.098,
    width: 25.5463,
    height: 4.42362,
    rx: 2.21181,
    transform: "rotate(-0.0805182 161.172 148.098)",
    fill: "#A4AEAF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.8368,
    y: 143.463,
    width: 19.2364,
    height: 5.13539,
    rx: 2.5677,
    transform: "rotate(-0.0805182 57.8368 143.463)",
    fill: "#234CFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.8502,
    y: 152.129,
    width: 38.1753,
    height: 5.13539,
    rx: 2.5677,
    transform: "rotate(-0.0805182 57.8502 152.129)",
    fill: "#E0E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.351 173.337C140.351 170.877 142.345 168.884 144.804 168.884H152.092C154.551 168.884 156.545 170.877 156.545 173.337C156.545 175.797 154.551 177.79 152.092 177.79H144.804C142.345 177.79 140.351 175.797 140.351 173.337Z",
    fill: "#234CFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.092 176.576C153.881 176.576 155.331 175.126 155.331 173.337C155.331 171.548 153.881 170.098 152.092 170.098C150.303 170.098 148.853 171.548 148.853 173.337C148.853 175.126 150.303 176.576 152.092 176.576Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.172,
    y: 171.233,
    width: 25.5463,
    height: 4.42362,
    rx: 2.21181,
    transform: "rotate(-0.0805182 161.172 171.233)",
    fill: "#A4AEAF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.8368,
    y: 166.597,
    width: 19.2364,
    height: 5.13539,
    rx: 2.5677,
    transform: "rotate(-0.0805182 57.8368 166.597)",
    fill: "#234CFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.8502,
    y: 175.264,
    width: 38.1753,
    height: 5.13539,
    rx: 2.5677,
    transform: "rotate(-0.0805182 57.8502 175.264)",
    fill: "#E0E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.351 196.472C140.351 194.012 142.345 192.019 144.804 192.019H152.092C154.551 192.019 156.545 194.012 156.545 196.472C156.545 198.932 154.551 200.925 152.092 200.925H144.804C142.345 200.925 140.351 198.932 140.351 196.472Z",
    fill: "#DFE2E7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.151 199.711C146.94 199.711 148.39 198.261 148.39 196.472C148.39 194.683 146.94 193.233 145.151 193.233C143.363 193.233 141.912 194.683 141.912 196.472C141.912 198.261 143.363 199.711 145.151 199.711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.172,
    y: 194.368,
    width: 25.5463,
    height: 4.42362,
    rx: 2.21181,
    transform: "rotate(-0.0805182 161.172 194.368)",
    fill: "#E0E7E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.8368,
    y: 189.732,
    width: 19.2364,
    height: 5.13539,
    rx: 2.5677,
    transform: "rotate(-0.0805182 57.8368 189.732)",
    fill: "#234CFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.8502,
    y: 198.399,
    width: 38.1753,
    height: 5.13539,
    rx: 2.5677,
    transform: "rotate(-0.0805182 57.8502 198.399)",
    fill: "#E0E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.792 125.699C146.792 129.256 143.908 132.139 140.351 132.139C136.794 132.139 133.911 129.256 133.911 125.699C133.911 122.142 136.794 119.259 140.351 119.259C143.908 119.259 146.792 122.142 146.792 125.699Z",
    fill: "#1EB27A",
    stroke: "#F4F5F8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.792 126.14V128.784H139.91V126.14H137.266V125.258H139.91V122.614H140.792V125.258H143.436V126.14H140.792Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -107.755,
    y: -87.7529,
    width: 461.273,
    height: 482.516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 72
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 123,
    y1: 0,
    x2: 123,
    y2: 246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE4F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 123,
    y1: 0,
    x2: 123,
    y2: 246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE4F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.16928,
    height: 6.16928,
    fill: "white",
    transform: "matrix(1 0 0 -1 137.266 128.784)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyOptionsMob);
export default __webpack_public_path__ + "static/media/empty-options-mob.b955e568.svg";
export { ForwardRef as ReactComponent };